<template>
  <div
    :class="`vertical-expander ${this.type === 'media' ? '--left':'--right'}`"
    @click="handleClick"
  >
    <span class="vertical-text">{{ text }}</span>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    text: String,
    type: String
  },
  methods: {
    ...mapMutations(["openSidebar"]),
    handleClick() {
      this.openSidebar(this.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.vertical-expander {
  position: absolute;
  display: block;
  right: 0;
  top: 0;
  width: 30px;
  height: 100%;
  background-color: #e8e8eb;
  cursor: pointer;

  &.--left {
    right: 0;
    left: auto;
  }

  &.--right {
    right: auto;
    left: 0;
  }

  &:hover {
    background-color: darken(#e8e8eb, 10%);

    .vertical-text {
      color: darken(#b5b5be, 10%);
    }
  }
}

.vertical-text {
  position: absolute;
  transform: rotate(-90deg);
  transform-origin: left top 0;
  top: 70px;
  left: 5px;
  width: 60px;
  text-align: right;
  color: #b5b5be;
  user-select: none;
}
</style>
